export const SIGN_IN_ROUTE_PREFIX = '/sign-in';

/* Sign-in pages that live outside the `/sign-in` prefix in React but sat under it in Angular. */
export const SIGN_IN_ROUTE_PATHS = [
  '/forgot-password',
  '/verify-identity',
  '/reset-password',
  '/create-password',
];

/* These partners suppress the header phone and its "or call" label, on every brand. */
export const PHONE_SUPPRESSED_CLIENTS = ['aflac', 'aflacmd'];

/* The `/activate/:client` and `/enrollment/:client` short links redirect into this one. */
export const ACTIVATE_CLIENT_ROUTE = '/enrollment/activate/:client';
